/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'permalink': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M8.61 9.525l1.415 1.414-2.475 2.475a2.5 2.5 0 003.416 3.648l.12-.112 2.475-2.475 1.414 1.414-2.475 2.475A4.5 4.5 0 116.136 12l2.475-2.475zm6.011-1.06l1.415 1.414-5.657 5.657-1.415-1.415 5.657-5.657zm4.243-2.829a4.5 4.5 0 010 6.364l-2.475 2.475-1.414-1.414 2.475-2.475a2.5 2.5 0 00-3.416-3.648l-.12.112-2.475 2.475-1.414-1.414L12.5 5.636a4.5 4.5 0 016.364 0z" _fill="#FFF"/></g>'
  }
})
